"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._GuardianForm = exports._GuardianZipcode = exports._GuardianCity = exports._GuardianHousenumber = exports._GuardianStreet = exports._GuardianBirthday = exports._GuardianEmail = exports._GuardianTelephoneMobilePrefix = exports._GuardianTelephoneMobile = exports._GuardianFamilyName = exports._GuardianGivenName = void 0;
var translation_1 = __importDefault(require("@src/services/translation"));
exports._GuardianGivenName = {
    uid: 'guardian.givenName',
    regex: /^\D{2,}$/,
    regexError: translation_1.default.t('noValidFirstname'),
    type: 'text',
    placeholder: 'Manfred',
};
exports._GuardianFamilyName = {
    uid: 'guardian.familyName',
    regex: /^\D{2,}$/,
    regexError: translation_1.default.t('noValidLastname'),
    type: 'text',
    placeholder: 'Mustermann',
};
exports._GuardianTelephoneMobile = {
    uid: 'guardian.phone',
    regex: /^(\d|\+)\d{4,}$/,
    regexError: translation_1.default.t('noValidPhoneNumber'),
    type: 'text',
    placeholder: '1754125011',
};
exports._GuardianTelephoneMobilePrefix = {
    uid: 'guardian.phonePrefix',
    type: 'text',
};
exports._GuardianEmail = {
    uid: 'guardian.email',
    regex: /^(?!.*\.\.)[a-zA-Z0-9_%+-]+(?:\.[a-zA-Z0-9_%+-]+)*@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/,
    regexError: translation_1.default.t('noValidEmail'),
    required: true,
    placeholder: 'manfred.mustermann@gmail.com',
    type: 'text',
};
exports._GuardianBirthday = {
    uid: 'guardian.birthday',
    type: 'dropdown',
    required: true,
};
exports._GuardianStreet = {
    uid: 'guardian.street',
    placeholder: 'musterstrasse',
    regex: /^.{3,99}$/,
    required: true,
    regexError: translation_1.default.t('noValidStreet'),
    type: 'text',
};
exports._GuardianHousenumber = {
    uid: 'guardian.housenumber',
    required: true,
    regex: /^.{1,10}$/,
    regexError: translation_1.default.t('noValidHousenumber'),
    type: 'text',
};
exports._GuardianCity = {
    uid: 'guardian.city',
    required: true,
    regex: /^.{3,99}$/,
    regexError: translation_1.default.t('noValidCity'),
    placeholder: 'musterhausen',
    type: 'text',
};
exports._GuardianZipcode = {
    uid: 'guardian.zipcode',
    required: true,
    regex: /^.{1,99}$/,
    regexError: translation_1.default.t('noValidZIP'),
    placeholder: '64315',
    type: 'text',
};
exports._GuardianForm = {
    email: exports._GuardianEmail,
    phone: exports._GuardianTelephoneMobile,
    familyName: exports._GuardianFamilyName,
    givenName: exports._GuardianGivenName,
    birthday: exports._GuardianBirthday,
    street: exports._GuardianStreet,
    housenumber: exports._GuardianHousenumber,
    city: exports._GuardianCity,
    zipcode: exports._GuardianZipcode,
};
